import { render, staticRenderFns } from "./funesPresF.vue?vue&type=template&id=078109fe"
import script from "./funesPresF.vue?vue&type=script&lang=js"
export * from "./funesPresF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports